module.exports = __webpack_public_path__ + "img/7.f6f4fa9b.png";